import { render } from "./ResetPasswordPage.vue?vue&type=template&id=bf5048a4&scoped=true"
import script from "./ResetPasswordPage.vue?vue&type=script&lang=ts"
export * from "./ResetPasswordPage.vue?vue&type=script&lang=ts"

import "./ResetPasswordPage.vue?vue&type=style&index=0&id=bf5048a4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-bf5048a4"

export default script